import { FIELD_TYPES } from "constants/template-field-type";
import { leadSourceConfigList } from "client/services/hubspot-service/hubspot-constants";
export default {
    source: {
        type: FIELD_TYPES.COMBO,
        label: "Lead Source",
        options: leadSourceConfigList
    },
    withPrivacyNotice: {
        type: FIELD_TYPES.BOOLEAN,
        label: "With Privacy Notice"
    },
    useNewBaseForm: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Use New Base Form",
        defaultValue: false
    },
    dontRenderPostFormSubmit: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Don't render post form submit (only for base form)",
        defaultValue: false
    }
};
